
export const awardData = [
    { type: '기획', '수상명': '대한민국 청년의 날 공로상', '수상내역': '공로상', '수상일자': '2018.09.01', '기관':'국회의원 김혜영, 신보라, 김수민' },
    { type: '기획', '수상명': '문화체육자원봉사 대학생 아이디어 공모전', '수상내역': '최우수상', '수상일자': '2018.12.14', '기관':'한국문화원연합회' },
    { type: '기획', '수상명': '피스 비즈니스 아이디어 공모전', '수상내역': '아이디어상', '수상일자': '2018.12.28', '기관':'무중력지대 서대문센터' },
    { type: '마케팅', '수상명': 'DGMIF 페이스북 콘텐츠 제작 공모전', '수상내역': '최우수상', '수상일자': '2019.03.15', '기관':'대구경북첨단의료산업진흥재단' },
    { type: '기획', '수상명': '찾아라 소셜 이노베이션 Rookie', '수상내역': '슈퍼루키상', '수상일자': '2019.03.30', '기관':'숙명여자대학교 창업지원단, 숙명여대 SK 루키' },
    { type: '개발', '수상명': '숙명 WIC powered by AWS 해커톤', '수상내역': '부총장상', '수상일자': '2019.11.23', '기관': '숙명여자대학교', 'projectId':'6' },
    { type: '개발', '수상명': '자기주도 진로설계 프로젝트', '수상내역': '우수상', '수상일자': '2020.08.06', '기관': '숙명여자대학교', 'projectId':'9' },
    { type: '기획', '수상명': '중견기업 분석 공모전', '수상내역': '장려상', '수상일자': '2020.11.25','기관': '숙명여자대학교' },
    { type: '마케팅', '수상명': 'K-MMM21 고혈압 유튜브 영상 공모전', '수상내역': '장려상', '수상일자': '2021.08.04','기관': '식품의약품안전처' },
    { type: '마케팅', '수상명': '한국산업인력공단 일학습병행 초능력기자단 우수활동상', '수상내역': '최우수상', '수상일자': '2021.11.26','기관': '한국산업인력공단' },
    { type: '데이터 분석', '수상명': '신빅해 : 디지털 신기술 혁신대학 신한금융그룹과 함께하는 빅데이터 해커톤 대회', '수상내역': '우수상', '수상일자': '2022.10.07','기관': '신한금융그룹, 디지털 신기술 혁신대학', 'projectId':'14' },
    { type: '개발', '수상명': '한이음 공모전', '수상내역': '입선', '수상일자': '2022.12.02', '기관': '한국정보산업연합회', 'projectId':'7' },
    
];

